import { render, staticRenderFns } from "./HealthcareROICalculator.vue?vue&type=template&id=fa75a2a4&scoped=true"
import script from "./HealthcareROICalculator.vue?vue&type=script&lang=js"
export * from "./HealthcareROICalculator.vue?vue&type=script&lang=js"
import style0 from "./HealthcareROICalculator.vue?vue&type=style&index=0&id=fa75a2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa75a2a4",
  null
  
)

export default component.exports